<button
  eBtn
  color="highlight"
  textColor="primary-50"
  size="sm"
  squared
  icon="expand-alt"
  tooltip="Openklappen"
  (click)="treeControl.expandAll()"
></button>

<button
  class="ml-2"
  eBtn
  color="highlight"
  textColor="primary-50"
  size="sm"
  squared
  icon="compress-alt"
  tooltip="Dichtklappen"
  (click)="treeControl.collapseAll()"
></button>
